module.exports = __webpack_public_path__ + "img/alfie-m9.d7292191.jpeg";